import React, { FunctionComponent } from 'react';

export interface IAdminActivateAccountComp {
    label?: string;
    CustomComp?: any;
    CustomLabelElement?: any;
    CustomTextComp?: any;
  }
const AdminActivateAccountComp: FunctionComponent<IAdminActivateAccountComp> = (
  {
    label,
    CustomComp,
    CustomLabelElement,
    CustomTextComp,
  },
) => {
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  return (
    <div className="activate-account">
      <div className="d-flex w-full flexed-between activate-cover">
        <div className="wrap">
          <div className="flexed-row">
            <h2 className="d-flex">
              {label}
              <div className="dot align-self-end" style={{ color: 'black' }}>
                .
              </div>
            </h2>
            {CustomLabelElement && <CustomLabelElement />}
          </div>

          <div className="onboarding-date d-flex">
            {!CustomTextComp ? (
              <>
                <p className="subtitle">
                  {days[new Date().getDay()]}
                  {new Date().getMonth() + 1}
                  ,
                  {new Date().getFullYear()}
                  .
                  {new Date().getHours()}
                  :
                  {`0${new Date().getMinutes()}`.slice(-2)}
                  {new Date().getHours() >= 12 ? 'PM' : 'AM'}
                </p>
                <p className="ml-4 subtitle">Last Login in yesterday at 12:45</p>
              </>
            ) : <CustomTextComp />}
          </div>
        </div>
        {CustomComp && (
        <div className="custom-comp">
          <CustomComp />
        </div>
        )}
      </div>
    </div>
  );
};
export default AdminActivateAccountComp;
